// @module C3.ShoppingExtensions.ReceiveUpdates
define('C3.ShoppingExtensions.ReceiveUpdates.View'
,	[
	'c3_shoppingextensions_receiveupdates.tpl'
	
	,	'C3.ShoppingExtensions.ReceiveUpdates.Model'
	,   'Backbone.FormView'
	
	,	'Backbone'
	,   'GlobalViews.Message.View'
	,   'Profile.Model'
	,   'UrlHelper'
	,   'AjaxRequestsKiller'
	,   'C3.ShoppingExtensions.LoginRegister.Register.Countries.View'
    ,   'C3.ShoppingExtensions.LoginRegister.Register.States.View'
    ]
, function (
	c3_shoppingextensions_receiveupdates_tpl
	
	,	ReceiveUpdatesModel
	,   BackboneFormView
	
	,	Backbone
	,   GlobalViewsMessageView
	,   ProfileModel
	,   UrlHelper
	,   AjaxRequestsKiller
	,   CountriesView
    ,   StatesView
)
{
    'use strict';

	// @class C3.ShoppingExtensions.ReceiveUpdates.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_receiveupdates_tpl

	,	initialize: function (options) {
			this.options = options;
			this.application = options.application;

			this.model = new ReceiveUpdatesModel();
			this.model.on('save', _.bind(this.redirect, this));

			this.profile = ProfileModel.getInstance()
			this.is_logged_in = this.profile.get('isLoggedIn') === 'T' && this.profile.get('isGuest') === 'F'
			
			this.countries = this.application.configuration.get('siteSettings.countries', []);


			if(this.is_logged_in)
            {
                var addressBook = this.profile.get('addressbook');

                var find_shippingAddr = _.findWhere(addressBook, {
                    defaultshipping: 'T'
                });

                if(find_shippingAddr)
                {
                    this.loggedUserCountry = find_shippingAddr.country
                    this.loggedUserState = find_shippingAddr.state
                }
            }

			BackboneFormView.add(this);
		}

	,  events: {
			'submit form': 'submitForm',
			'click [data-action="opt-out-all"]' : 'optOutAll',
			'change [data-action="selectcountry"]': 'updateStates',
		}

	,	bindings: {
			'[name="firstname"]': 'firstname',
	        '[name="lastname"]': 'lastname',
	        '[name="email"]': 'email',
	        '[name="pricedrop"]': 'pricedrop',
	        '[name="lowinventory"]': 'lowinventory',
	        '[name="backinstock"]': 'backinstock',
	        '[name="custentity_destination_country"]': 'custentity_destination_country',
        	'[name="custentity_customer_state"]': 'custentity_customer_state'
		}

	,  updateStates: function(e){
            var statesView = this.getChildViewInstance('States.Dropdown');
            var selectedCountry= $(e.currentTarget).val();

            var self = this;
             
            var find_country = _.findWhere(self.countries, {
                    name: selectedCountry
                });

            //console.log(this)
            
            if(find_country)
            {
                //var available_states = find_country.states;
                statesView.options.selectedCountry = find_country.code;
                this.selectedCountry = find_country.code;
                statesView.render();

            }
            else{
                statesView.options.selectedCountry = '';
                this.selectedCountry = '';
                statesView.render();
            }
            //console.log(statesView)
        }		

	,  childViews: {
            'Countries.Dropdown': function() {
                //console.log(this.countries)
                if(this.loggedUserCountry)
                this.selectedCountry =  this.loggedUserCountry;

                return new CountriesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    manage: this.options.manage
                });
            },
            'States.Dropdown': function() {
                //console.log(this.loggedUserState)
                if(this.loggedUserState)
                this.selectedState =    this.loggedUserState;

                if(this.loggedUserCountry)
                this.selectedCountry =  this.loggedUserCountry;

                return new StatesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    selectedState: this.selectedState,
                    manage: this.manage
                });
            }
    }  

	,  optOutAll: function(e)
		{
			var currentTarget = $(e.currentTarget)
        	,   currentTargetProp = currentTarget.prop('checked')

        	//console.log(currentTargetProp)
        	if(currentTargetProp == true)
        	{
				$('.pricedrop').attr('checked','F');
				$('.pricedrop').prop('checked',false);
				$('.pricedrop').attr('disabled','disabled');

				$('.lowinventory').attr('checked','F');
				$('.lowinventory').prop('checked',false);
				$('.lowinventory').attr('disabled','disabled');

				$('.backinstock').attr('checked','F');
				$('.backinstock').prop('checked',false);
				$('.backinstock').attr('disabled','disabled');

				$(".submit-form").prop('disabled',false);
                $(".submit-form").css('background','#4b99c0');
			}
			else if(currentTargetProp == false){
				$('.pricedrop').prop('disabled',false);
				$('.lowinventory').prop('disabled',false);
				$('.backinstock').prop('disabled',false);

				$(".submit-form").prop('disabled','disabled');
                $(".submit-form").css('background','#c0bfbf');
			}
		}

	,   render: function()
		{
			/*let url = Backbone.history.location.href;
            url = UrlHelper.UrlHelper.setUrlParameter(url,'recid',98);

			console.log(url)

			var self = this;

			this.model.fetch({
                data: {
                    action: 'FETCH',
                    RU_IID : 98
                },
                killerId: AjaxRequestsKiller.getKillerId()
            }).done(function(result) {
            		console.log(result)
					self._render();
            });*/
			/*var self = this;
            if(this.is_logged_in)
			{
				var customerId = this.profile.get('internalid')
				console.log(customerId)

				this.model.fetch({
                data: {
                    action: 'FETCH',
                    customerIID : customerId
                },
	                killerId: AjaxRequestsKiller.getKillerId()
	            }).done(function(result) {
	            		console.log(result)
						self._render();
	            });
			}
			else{
				this._render();
			}*/

			this._render();
		}		

	,   submitForm: function(e, model, props)
		{
			e.preventDefault();

	        var self = this;
	        var data = (jQuery(e.target).closest('form')).serializeObject();
	       	console.log(data)

        	return this.cancelableTrigger('before:C3.ShoppingExtensions.ReceiveUpdates', data).then(function() {
              self.saveForm(e, model, props);
        	});
		}	

	,   redirect: function(context, response)
		{
			//console.log(response)
			var responseData = response.responseData
			,   parseResponseData = null
			,   responseStatus = ''
			,   message = ''
			,   type = ''

			try {
				parseResponseData = JSON.parse(responseData)
				responseStatus = parseResponseData && parseResponseData.status
			} catch (parseErr) {
				parseResponseData = { status: 'fail' }
				responseStatus = 'fail'
			}

			if(parseResponseData)
			{
				if(responseStatus == "success"){
					 message = "You've successfully submitted the request."
					 type = 'success'
				}else{
					 message = "An error occured while submitting the request."
					 type = 'warning'
				}
				//var message = "You've successfully submitted the request."
				var $alert_placeholder = $('.receive-updates-msg-placeholder');
				var alert = new GlobalViewsMessageView({
	                message: message,
	                type: type,
	                closable: true
	            });
	            alert.show($alert_placeholder, 8000);
				
				//console.log(responseStatus)
			}
		}	

		//@method getContext @return C3.ShoppingExtensions.ReceiveUpdates.View.Context
	,	getContext: function getContext()
		{
			var config = this.application.Configuration
			,   navigationData = config.navigationData
			,   showBackInStock = false

			var findCategories = _.findWhere(navigationData, {
	                    href: '/categories'
	                });
			var subCats = findCategories && findCategories.categories;
			var findTargetedCategory = subCats && _.findWhere(subCats, {
	                    text: this.options.itemProductGroup
	                });

			var itemType = this.options.itemType
			,   invQty = this.options.itemInvQty
			,   kitQty = this.options.itemKitQty

			//console.log(invQty)

			if(invQty == undefined)
				invQty = 0;

			if(kitQty == undefined)
				kitQty = 0;

			if(itemType == 'Kit')
			{
				if(kitQty <= 0){
					showBackInStock = true;
				}
			}
			else if(itemType == 'InvtPart' || itemType == 'Assembly')
			{
				if(invQty <= 0){
					showBackInStock = true;
				}
			}

			var loggedUserFirstName = ''
			,   loggedUserLastName = ''
			,   loggedUserEmail = ''
			,   userId = ''


			if(this.is_logged_in)
			{
				loggedUserFirstName = this.profile.get('firstname')
				loggedUserLastName = this.profile.get('lastname')
				loggedUserEmail = this.profile.get('email')
				userId = this.profile.get('internalid')
			}

			

			return {
				loggedUserFirstName : loggedUserFirstName,
				userId: userId,
				loggedUserLastName : loggedUserLastName,
				loggedUserEmail : loggedUserEmail,
				isLoggedIn : this.is_logged_in,
				itemsku : this.options.itemid,
	        	itemname : this.options.itemname,
	        	itemInternalId : this.options.internalid,
	        	itemImgUrl : this.options.itemImgUrl,
	        	safariBrowserMac : (typeof navigator !== 'undefined' && navigator.vendor.indexOf('Apple') > -1) ? true : false,
	        	showBackInStock : showBackInStock,
	        	shopAllLink : findTargetedCategory && "https://"+SC.ENVIRONMENT.shoppingDomain+findTargetedCategory.href
			};
		}
	});
});
